module.exports = __webpack_public_path__ + "static/media/benefit_1.00d4541b.svg";